import { render, staticRenderFns } from "./ResearchCource.vue?vue&type=template&id=0c767426&scoped=true"
import script from "./ResearchCource.vue?vue&type=script&lang=js"
export * from "./ResearchCource.vue?vue&type=script&lang=js"
import style0 from "./ResearchCource.vue?vue&type=style&index=0&id=0c767426&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c767426",
  null
  
)

export default component.exports